import {createSlice} from '@reduxjs/toolkit'

import {createTicketThunk} from './thunks'

import APP_NAME from 'airship/modules/app_name'
import APP_KEY from 'airship/modules/app_key'

export type Details = {
  product: string
  issueDescription: string
  appName: string
  url: string
  appKey: string
  urgency: 'low' | 'medium' | 'highest' | 'urgent'
  recaptchaToken?: string
}

export type State = {
  loading: boolean
  errorMessage?: string
  ticketNumber: number
  details: Details
}

export const initialState: State = {
  loading: false,
  errorMessage: '',
  ticketNumber: 0,
  details: {
    product: '',
    issueDescription: '',
    appName: APP_NAME,
    url: window.location.href,
    appKey: APP_KEY,
    urgency: 'low',
  },
}

const detailsSlice = createSlice({
  name: 'details',
  initialState,
  reducers: {
    clearFields(state) {
      Object.assign(state, initialState)
    },
    updateDetails(state, action) {
      state.details.appName = action.payload.appName
      state.details.url = action.payload.url
      state.details.appKey = action.payload.appKey
    },
    updateIssueDescription(state, action) {
      state.details.issueDescription = action.payload
    },
    updateProduct(state, action) {
      state.details.product = action.payload
    },
    updateUrgency(state, action) {
      state.details.urgency = action.payload
    },
    updateErrorMessage(state, action) {
      state.errorMessage = action.payload
    },
    clearErrorMessage(state) {
      state.errorMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTicketThunk.pending, (state) => {
        state.loading = true
      })
      .addCase(createTicketThunk.fulfilled, (state, {payload}) => {
        state.loading = false
        state.ticketNumber = payload.ticketNumber
        state.errorMessage = ''
      })
      .addCase(createTicketThunk.rejected, (state) => {
        state.loading = false
        state.errorMessage =
          'There was a problem creating your ticket. If you continue to encounter this error, you can also submit your ticket in our Product Support Portal at https://support.airship.com.'
      })
  },
})

export default detailsSlice
